import { useIntl } from 'react-intl';

import { Typography } from '../../../../../../../design-system/components/typography/Typography';
import { HubDestinationMenu } from '../../../../../../../resources/hubDestinationMenu/domain/types/hubDestinationMenu';
import { PrimaryNavFacetCard } from '../../../../Shared/PrimaryNavFacetCard/PrimaryNavFacetCard';

import style from './HubDestinationFacets.module.css';

export function HubDestinationFacets({
    hubDestinationMenu,
}: {
    hubDestinationMenu: HubDestinationMenu;
}) {
    const { formatMessage } = useIntl();
    const { destination, facets } = hubDestinationMenu;

    return (
        <div>
            <Typography className={style.title} as="div" scale="primary-s-extra-bold">
                {formatMessage({ id: 'global.header.globalNav.hubDestination.facets.title' })}
            </Typography>

            <div className={style.carousel}>
                <div className={style.scroller}>
                    {facets.map((facet, index) => {
                        return (
                            <div key={facet.id} className={style.slide}>
                                <PrimaryNavFacetCard
                                    facet={facet}
                                    index={index}
                                    destination={destination}
                                />
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
